import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import {Auth} from '@aws-amplify/auth'
import AmplifyStore from "./store/store";
// Initialise the Vue router module
Vue.use(Router);

async function getUser() {
  try {
    const data = await Auth.currentAuthenticatedUser();
    if (data && data.signInUserSession) {
      AmplifyStore.commit("setUser", data);
      return data;
    }
    return null;
  } catch {
    AmplifyStore.commit("setUser", null);
    return null;
  }
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: { requiresAuth: false }
    },
    { path: "/auth", redirect: { name: "login" } },
    /*
         Injectors
    */
    {
      path: "/injectors",
      name: "injectors",
      component: () => import("./views/InjectorsPublic.vue"),
      meta: { requiresAuth: false }
    },
    {
      path: "/injector/summary/:injector_id",
      name: "injector_summary",
      component: () => import("./views/InjectorSummary.vue"),
      meta: { requiresAuth: false }
    },
    {
      path: "/injectors/:injector_id",
      name: "injectors_by_id",
      component: () => import("./views/InjectorsPublic.vue"),
      meta: { requiresAuth: true }
    },
    /*
         Injector Types
        */
    {
      path: "/types/admin",
      name: "injector_types_admin",
      component: () => import("./views/InjectorTypesAdmin.vue"),
      meta: { requiresAuth: true }
    },
    {
      path: "/types/detailed/:injector_type_id",
      name: "types_by_id",
      component: () => import("./views/InjectorTypeDetail.vue"),
      meta: { requiresAuth: true }
    },
    /*
      Groups
    */
    {
      path: "/group/bounce",
      name: "group_bounce",
      component: () => import("./views/GroupBounce.vue"),
      meta: { requiresAuth: false }
    },
    {
      path: "/group/summary/:group_name",
      name: "group_summary",
      // route level code-splitting
      component: () => import("./views/GroupSummary.vue"),
      meta: { requiresAuth: false }
    },
    {
      path: "/group/detailed/:group_name",
      name: "group_detail",
      component: () => import("./views/GroupDetail.vue"),
      meta: { requiresAuth: true }
    },
    {
      // Shorter URL for redirect and easier typing
      path: "/g/:group_name",
      name: 'group_summary_short_url',
      redirect: { 'name': 'group_summary' }
    },
    /* Utility and Help */
    // {
    //   path: "/help",
    //   name: "user_help",
    //   component: () => import("./views/HelpForUsers.vue"),
    //   meta: { requiresAuth: false }
    // },
    {
      path: "/terms-and-conditions",
      name: "terms_and_conditions",
      component: () => import("./views/TermsAndConditions.vue"),
      meta: { requiresAuth: false }
    },
    /* 404 page */
    {
      path: "*",
      component: () => import("./views/PageNotFound.vue"),
      meta: { requiresAuth: false }
    }
  ]
});

router.beforeResolve(async (to, _from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const user = await getUser();
    if (!user) {
      return next({
        path: "/",
        query: {
          redirect: to.fullPath
        }
      });
    }
    return next();
  }
  return next();
});

export default router;
